import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter, Button, Tooltip } from '@gpstrackit/gtc-react-controls';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

import { TypeObjectMap, TypeLayer } from 'Components/Map/providers/enums'

import { IconReactMarkerRouteFSMPoint } from '../../../../../../components/Map/iconsReact'

import {
    Grid,
    Typography
  } from '@mui/material';

import './style.scss'

import {
    openModalMarkerRoute, onUpdateRoute
  } from 'Redux/actions';

import { openModalRouteDirections } from '../modalDirections/redux/slice'

const ModalMarkerRoute = (props) => {

    const { data : paramData, mapRef, setFormData } = props

    const { messages, locale } = useIntl();
    const dispatch = useDispatch();
 
    const [showModalMarkerRoute, setModalMarkerRoute] = useState(true)

    const openModalMarkerInfo = useSelector(state => state.routesManagerModalMarkerRouteRedux);
    const { user: { isKph }, user } = useSelector((state) => state.securityRedux);
    const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);

    let newPointers = []
    //create the points on map when route comes to data
    if(route){
        route?.points?.map((item) => {
            newPointers.push({
                ...item, 
                layerName: TypeLayer?.FSMRoute,
                eventName: item?.typePoint
            })
        });
    }

    const data = paramData || newPointers

    useEffect(() => {
        dispatch(openModalRouteDirections({ open: false }))
    },[])

    const handleModalMaker = () => {
        //param comes to click on marker
        setModalMarkerRoute(!showModalMarkerRoute)
    }

    if(!openModalMarkerInfo?.open){
        return (<></>)
    } else if(data) {

        //get this info to the API
        let item = null;
        item = data.find((item) => item.id ==  openModalMarkerInfo?.data?.id);

        if(!item) return (<></>)

        //let colorTypePoint = '#f50057';
        let colorTypePoint = item?.typePoint == 'Stop' ? '#f50057': '#ff6623';

        return (
            <SidePanel 
                isOpen={true} 
                onToggle={handleModalMaker} 
                hiddenButton={true} 
                style={{ width: '350px', transform: 'translateX(350px)' }} 
                position={"left"}
            >
                <SidePanelHeader>
                    <div className={cx('route-modal-title-format-base', item?.typePoint == 'Stop'? "route-modal-title-format-base-stop" : "route-modal-title-format-base-waypoint")}>
                        {item?.typePoint == "Stop" ? messages['fsmRoute_modal_label_stop'] : messages['fsmRoute_modal_label_waypoint']}
                    </div>

                </SidePanelHeader>
                <SidePanelBody>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: '80%',
                        }}
                    >
                        <Grid
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >

                            <Grid container direction="row" columns={12} className="route-modal-items">
                                <Grid item xs={4}>
                                    <Typography className='route-modal-label'>{messages["fsmRoute_label_stop"]}:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Grid item>
                                        <div key={item?.sequence}  className="route-modal-items-div">
                                        <IconReactMarkerRouteFSMPoint color={colorTypePoint} number={item?.typePoint == "Stop" ? item?.value + 1: ''} />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" columns={12} className="route-modal-items">
                                <Grid item xs={4}>
                                    <Typography className='route-modal-label' >{messages["fsmRoute_label_name"]}:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Tooltip title={item?.name} placement={'bottom'} /* type={ props?.tooltipType || null} */ >
                                        <Typography className='route-modal-value modal-marker-cut-text' >{item?.name}</Typography>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" columns={12} className="route-modal-items">
                                <Grid item xs={4}>
                                    <Typography className='route-modal-label' >{messages["fsmRoute_label_address"]}:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className='route-modal-value' >{item?.address}</Typography>
                                </Grid>
                            </Grid>
                            {
                                item?.typePoint == "Stop"
                                &&
                                <Grid container direction="row" columns={12} className="route-modal-items">
                                    <Grid item xs={4}>
                                        <Typography className='route-modal-label' >{messages["fsmRoute_label_radius"]}:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography className='route-modal-value' >{`${isKph ? (item?.radius * 0.001).toFixed(2) : (item?.radius * 0.000621371).toFixed(2)} ${isKph ? messages['kilometers'] : messages['miles']}`}</Typography>
                                    </Grid>
                                </Grid>
                            }
                            <Grid container direction="row" columns={12} className="route-modal-items">
                                <Grid item xs={4}>
                                    <Typography className='route-modal-label' >{messages["fsmRoute_label_display"]}:</Typography>
                                </Grid>
                                <Grid item xs={8} style={{ whiteSpace: 'nowrap',  cursor: 'pointer' }}>
                                    <label 
                                        style={{ textDecoration: 'underline', color: '#00AEEF', cursor: 'pointer' }} 
                                        className='route-modal-value'
                                        onClick={()=> {
                                            mapRef.current.centerObjectOnMap(TypeObjectMap.Marker, item.id, 16);
                                        }}
                                     >
                                        {messages['fsmRoute_modal_label_street_level']}
                                     </label>
                                    <label>{" | "}</label>
                                    <label 
                                        style={{ textDecoration: 'underline', color: '#00AEEF', cursor: 'pointer' }} 
                                        className='route-modal-value'
                                        onClick={()=>{
                                            const coordinatesCenter = []
                                            data.forEach(element => {
                                                coordinatesCenter.push({
                                                    lat: element.latitude, lng: element.longitude
                                                })
                                            });
                                            mapRef.current.centerByFitBounds(coordinatesCenter)
                                        }}>
                                            {messages['fsmRoute_modal_label_route_level']}
                                    </label>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" columns={12} className="route-modal-items">
                                <Grid item xs={4}>
                                    <Typography className='route-modal-label' >{messages["fsmRoute_label_notes"]}:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className='route-modal-value route-modal-note' >{item?.note}</Typography>
                                </Grid>
                            </Grid>
                            <Grid>
                                {
                                    /* label for info message to start and end point */
                                    (item?.sequence == 0 || (item?.sequence == route?.points?.length - 1 || route?.points?.length <= 2))
                                    &&
                                    <div style={{ paddingRight: 20 }}>
                                        <div className='route-modal-info-message'>
                                            <Typography className='route-modal-value' >{
                                            (item?.sequence == 0) ?
                                            item?.typePoint == 'Stop' ? messages['fsmRoute_edit_panel_route_info_points_stop_start'] : messages['fsmRoute_edit_panel_route_info_points_waypoint_start']
                                            : 
                                            item?.typePoint == 'Stop' ? messages['fsmRoute_edit_panel_route_info_points_stop_end'] : messages['fsmRoute_edit_panel_route_info_points_waypoint_end']
                                            }</Typography>
                                        </div>
                                    </div> 
                                }
                            </Grid>                            
                        </Grid>
                    </div> 
                </SidePanelBody>
                <SidePanelFooter>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        }}
                    >
                        <Button
                            variant="secondary"
                            style={{ marginRight: 8 }}
                            onClick={() => {
                                mapRef.current.showNormalMarkers()
                                dispatch(openModalMarkerRoute({open: false, data: null}))
                            }}
                        >
                            {messages['fsmRoute_label_close']}
                        </Button>
                        <Button 
                            variant="warning" 
                            onClick={(e) => { 
                                e.preventDefault();    
                                //delete route point

                                const pointToDelete = [];
                                let sequence = 0
                                route?.points?.forEach((point) => {
                                    if(!(point.id == item.id && point.name == item.name)){
                                    pointToDelete.push({
                                        ...point,
                                        sequence: sequence
                                    })
                                    sequence += 1;
                                    }
                                });
                                //setFormData(formData => ({ ...formData, points: pointToDelete }));
                                dispatch(onUpdateRoute({ route: { ...route, points: pointToDelete }, changesToSave: true }));
                            }}
                            >
                            { item?.typePoint == "Stop" ? messages['fsmRoute_modal_label_route_delete_stop'] : messages['fsmRoute_modal_label_route_delete_waypoint']}
                        </Button>
                    </div>      
                </SidePanelFooter>
            </SidePanel>
            
        )
    }
}

export default ModalMarkerRoute;

